import React, { ChangeEvent, FormEvent, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from '../../ui/toast';
import LogoWhite from '../../assets/images/logos/white-bg-logo-hiacuity.png';
import { Button } from '../../ui';
import { TextInput } from '../../ui/input/text_input/text_input';
import { adminLogin } from '../../utils/api_service/admin';
import { AuthenticationUiLayout } from '../login_register/AuthenticationUILayout';

const AdminLogin = () => {

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const history = useHistory();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      const res = await adminLogin({ username, password });

      if (res.ok) {
        const result = await res.json();
        localStorage.setItem('adminToken', result.access_token);
        history.push('/organizations');
      } else {
        toast.error('Invalid login', { position: 'bottom-center' });
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div>
      <AuthenticationUiLayout
          leftContent={
            <div className='flex flex-col items-center gap-6'>
              <div className='w-20 h-20 rounded-2xl bg-white/20 backdrop-blur-md flex items-center justify-center border border-white/30 shadow-xl'>
                <svg
                    className='w-10 h-10 text-white'
                    fill='none'
                    stroke='currentColor'
                    viewBox='0 0 24 24'
                >
                  <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z'
                  />
                </svg>
              </div>
              <div className='space-y-2'>
                <h2 className='text-4xl font-bold tracking-tight'>
                  Admin Login
                </h2>
                <p className='text-emerald-50/80 text-lg max-w-xs mx-auto'>
                  Empowering your talent acquisition with intelligent assessments.
                </p>
              </div>
            </div>
          }
      >
        <div className='flex items-start flex-col w-full gap-6 pt-4'>
          <img src={LogoWhite} alt='Logo' className='w-[200px]' />
          <h1 className='text-xl md:text-2xl font-semibold text-slate-900 tracking-tight'>
            Admin Login
          </h1>
        </div>
        <form
            className='flex flex-col space-y-6 mt-10 pb-10'
            onSubmit={handleSubmit}
            data-testid='login-form'
        >
          <TextInput
              type='text'
              label='Username'
              name='email'
              value={username}
              onChange={(e: ChangeEvent<HTMLInputElement>) => setUsername(e.target.value)}
              required
          />
          <TextInput
              type='password'
              label='Password'
              name='password'
              value={password}
              onChange={(e: ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
              required
          />
          <Button type='submit' label='Login' variant='primary' />
        </form>
      </AuthenticationUiLayout>
    </div>
  );
};

export default AdminLogin;
